import React from 'react'

export const LinkedIn = (props) => {
  return (
    <>
     <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="#000">
      <path d="M12.5 12h-3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5zM12 23h-2V13h2v10zM11 7c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 3a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2zM19.515 11.986a3.99 3.99 0 0 0-1.554.32A.5.5 0 0 0 17.5 12h-3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5l-.002-6.661c0-.003-.012-.336.2-.565.167-.182.452-.274.846-.274.652 0 .956.279.956.879V23.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-6.842c0-3.448-2.416-4.672-4.485-4.672zM23 23h-2v-6.121C21 15.72 20.251 15 19.044 15c-.684 0-1.216.2-1.581.595A1.828 1.828 0 0 0 17 16.879V23h-2V13h2v.355a.5.5 0 0 0 .991.092c.134-.146.722-.46 1.523-.46.817 0 3.485.265 3.485 3.671V23z" />
      <path d="M16-.035C7.158-.035-.034 7.159-.034 16S7.158 32.035 16 32.035 32.034 24.841 32.034 16 24.842-.035 16-.035zm0 31C7.748 30.965 1.034 24.252 1.034 16S7.748 1.035 16 1.035 30.966 7.748 30.966 16 24.252 30.965 16 30.965z" />
    </g>
  </svg>
    </>
  )
}
